// NOTE: Enum values must not exceed the UInt8 range (0–255)
var calls;
(function (calls) {
    calls[calls["createAction"] = 1] = "createAction";
    calls[calls["signAction"] = 2] = "signAction";
    calls[calls["abortAction"] = 3] = "abortAction";
    calls[calls["listActions"] = 4] = "listActions";
    calls[calls["internalizeAction"] = 5] = "internalizeAction";
    calls[calls["listOutputs"] = 6] = "listOutputs";
    calls[calls["relinquishOutput"] = 7] = "relinquishOutput";
    calls[calls["getPublicKey"] = 8] = "getPublicKey";
    calls[calls["revealCounterpartyKeyLinkage"] = 9] = "revealCounterpartyKeyLinkage";
    calls[calls["revealSpecificKeyLinkage"] = 10] = "revealSpecificKeyLinkage";
    calls[calls["encrypt"] = 11] = "encrypt";
    calls[calls["decrypt"] = 12] = "decrypt";
    calls[calls["createHmac"] = 13] = "createHmac";
    calls[calls["verifyHmac"] = 14] = "verifyHmac";
    calls[calls["createSignature"] = 15] = "createSignature";
    calls[calls["verifySignature"] = 16] = "verifySignature";
    calls[calls["acquireCertificate"] = 17] = "acquireCertificate";
    calls[calls["listCertificates"] = 18] = "listCertificates";
    calls[calls["proveCertificate"] = 19] = "proveCertificate";
    calls[calls["relinquishCertificate"] = 20] = "relinquishCertificate";
    calls[calls["discoverByIdentityKey"] = 21] = "discoverByIdentityKey";
    calls[calls["discoverByAttributes"] = 22] = "discoverByAttributes";
    calls[calls["isAuthenticated"] = 23] = "isAuthenticated";
    calls[calls["waitForAuthentication"] = 24] = "waitForAuthentication";
    calls[calls["getHeight"] = 25] = "getHeight";
    calls[calls["getHeaderForHeight"] = 26] = "getHeaderForHeight";
    calls[calls["getNetwork"] = 27] = "getNetwork";
    calls[calls["getVersion"] = 28] = "getVersion";
})(calls || (calls = {}));
export default calls;
//# sourceMappingURL=WalletWireCalls.js.map